module.exports = __webpack_public_path__ + "assets/2230252de5790b382f7c67243f59fe08.png";